import "./scss/index.scss";
import React from "react";
import { InstagramHeader } from "../../InstagramHeader";
import { InstagramItemsStatic } from "../../InstagramItemsStatic";
export function SliceInstagramStatic(_ref) {
  var primary = _ref.primary;
  var _ref2 = primary.content_relationship,
      title = _ref2.title,
      user_name = _ref2.user_name,
      text = _ref2.text,
      posts = _ref2.posts;
  return React.createElement("div", {
    className: "instagram-container"
  }, React.createElement("div", {
    className: "container padding-left"
  }, React.createElement(InstagramHeader, {
    title: title,
    user_name: user_name,
    text: text
  }), posts && React.createElement(InstagramItemsStatic, {
    items: posts
  })));
}
SliceInstagramStatic.componentName = "instagram";
export default SliceInstagramStatic;